// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pagos · Plataforma (backoffice) — cola de payouts en TARJETAS.
   Cada deal es una card legible (la info no cabe en una tabla apretada): cabecera
   con fecha · estado · monto · acciones, campos clave debajo, y el detalle de
   soporte expandible al hacer click. Tokens del design system; sin hex sueltos. */

/* barra de tabs (PageTabs) alineada al padding del contenido */
.plp-tabs {
  padding: 10px 24px 0;
}

/* franja (sección) */
.plp-franja {
  margin: 0;
  padding-bottom: 28px;
}
.plp-franja:last-of-type {
  padding-bottom: 96px;
}
.plp-franja__cap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted);
  padding: 20px 24px 10px;
}
.plp-franja__cap b {
  color: var(--text-secondary);
  font-weight: 500;
}
.plp-selall {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-secondary);
  cursor: pointer;
}
.plp-selall input {
  cursor: pointer;
}
.plp-empty {
  margin: 0 24px;
  border: 1px dashed var(--border);
  border-radius: var(--r-data);
  padding: 16px 18px;
  font-size: var(--fs-2xs);
  color: var(--text-muted);
  background: var(--bg-alt);
}
.plp-empty.is-err {
  border-style: solid;
  border-color: var(--danger);
  color: var(--danger);
  display: flex;
  align-items: center;
  gap: 12px;
}

/* ── tarjetas ── */
.plp-cards {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 24px;
}
.plp-card {
  border: 1px solid var(--border);
  border-radius: var(--r-dialog);
  background: var(--bg-alt);
  padding: 14px 16px;
  cursor: pointer;
  transition: border-color 0.12s ease;
}
.plp-card:hover {
  border-color: var(--text-muted);
}
.plp-card.is-open {
  border-color: var(--text-secondary);
}
.plp-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.plp-card__lead {
  display: flex;
  align-items: center;
  gap: 12px;
}
.plp-card__lead input[type='checkbox'] {
  cursor: pointer;
}
.plp-card__right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.plp-card__chev {
  font-family: var(--mono);
  font-size: var(--fs-meta);
  color: var(--text-muted);
}
.plp-date {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
  font-size: var(--fs-2xs);
  color: var(--text-secondary);
}
.plp-money {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
  font-size: var(--fs-note);
  color: var(--text);
  white-space: nowrap;
}

/* campos clave de la card */
.plp-card__fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 12px 24px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border-soft);
}
.plp-cf {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.plp-cf__l {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 3px;
}
.plp-cf__v {
  font-size: var(--fs-ui);
  color: var(--text);
  line-height: 1.3;
}
.plp-cf__s {
  font-size: var(--fs-sm);
  color: var(--text-muted);
  font-family: var(--mono);
  margin-top: 2px;
  word-break: break-word;
}
.plp-cf__s.is-err {
  color: var(--danger);
}

/* acciones (Shinkansen + Manual) */
.plp-actions {
  display: inline-flex;
  gap: 8px;
}
.plp-rowbtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 12px;
  border: 1px solid var(--ink-dark);
  border-radius: var(--radius-0);
  background: var(--ink-dark);
  color: var(--cream);
  font-family: var(--sans);
  font-size: var(--fs-meta);
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}
[data-theme='dark'] .plp-rowbtn {
  background: var(--cream);
  color: var(--ink-dark);
  border-color: var(--cream);
}
.plp-rowbtn--ghost {
  background: transparent;
  color: var(--text-secondary);
  border-color: var(--border);
}
[data-theme='dark'] .plp-rowbtn--ghost {
  background: transparent;
  color: var(--text-secondary);
  border-color: var(--border);
}
.plp-rowbtn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* ── detalle de soporte (expandido dentro de la card) ── */
.plp-card__detail {
  margin-top: 12px;
  padding-top: 4px;
  border-top: 1px solid var(--border);
  cursor: default;
}
.plp-detail {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px 28px;
  padding: 14px 0 4px;
}
.plp-detail__sec {
  min-width: 0;
}
.plp-detail__h {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin: 0 0 8px;
}
.plp-field {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 10px;
  padding: 3px 0;
  align-items: baseline;
}
.plp-field__l {
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
.plp-field__v {
  font-size: var(--fs-meta);
  color: var(--text);
  word-break: break-word;
}
.plp-field__v.is-mono {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
  font-size: var(--fs-xs);
  user-select: all;
}

/* paginación */
.plp-more {
  padding: 14px 24px 0;
}
.plp-morebtn {
  height: 30px;
  padding: 0 14px;
  border: 1px solid var(--border);
  border-radius: var(--radius-0);
  background: var(--bg-alt);
  color: var(--text-secondary);
  font-family: var(--mono);
  font-size: var(--fs-xs);
  cursor: pointer;
}
.plp-morebtn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* barra de selección (lote → pago manual) */
.plp-selbar {
  position: fixed;
  bottom: 18px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 40;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 16px;
  border-radius: var(--radius-0);
  border: 1px solid var(--text);
  background: var(--ink-dark);
  color: var(--cream);
  box-shadow: 0 10px 30px -8px rgba(0, 0, 0, 0.45);
  font-size: var(--fs-2xs);
}
.plp-selbar__txt b {
  font-family: var(--mono);
}
.plp-selbar__sp {
  width: 8px;
}
.plp-selbar__ghost {
  border: 1px solid rgba(242, 227, 181, 0.35);
  background: transparent;
  color: var(--cream);
  height: 28px;
  padding: 0 12px;
  border-radius: var(--radius-0);
  font-family: var(--sans);
  font-size: var(--fs-meta);
  cursor: pointer;
}
.plp-selbar__seal {
  border: 1px solid var(--cream);
  background: var(--cream);
  color: var(--ink-dark);
  height: 28px;
  padding: 0 14px;
  border-radius: var(--radius-0);
  font-family: var(--sans);
  font-size: var(--fs-meta);
  font-weight: 500;
  cursor: pointer;
}
.plp-selbar__seal:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* fecha del pago manual, dentro de la confirmación */
.plp-paidat {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.plp-paidat__l {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.plp-paidat input {
  font-family: var(--mono);
  font-size: var(--fs-2xs);
  padding: 5px 8px;
  border: 1px solid var(--border);
  border-radius: var(--radius-0);
  background: var(--bg);
  color: var(--text);
}

/* qué hecho es la fecha de la cabecera: cada carril muestra el suyo */
.plp-date__l {
  font-size: var(--fs-micro);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/pages/plataforma/PlataformaPagos.css"],"names":[],"mappings":"AAAA;;;kFAGkF;;AAElF,+DAA+D;AAC/D;EACE,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,wBAAwB;EACxB,kCAAkC;EAClC,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;;AAEA,mCAAmC;AACnC;EACE,oBAAoB;EACpB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;EAC5B,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,mBAAmB;EACnB,gDAAgD;EAChD,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,UAAU;AACZ;AACA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,sEAAsE;AACtE;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B","sourcesContent":["/* Pagos · Plataforma (backoffice) — cola de payouts en TARJETAS.\n   Cada deal es una card legible (la info no cabe en una tabla apretada): cabecera\n   con fecha · estado · monto · acciones, campos clave debajo, y el detalle de\n   soporte expandible al hacer click. Tokens del design system; sin hex sueltos. */\n\n/* barra de tabs (PageTabs) alineada al padding del contenido */\n.plp-tabs {\n  padding: 10px 24px 0;\n}\n\n/* franja (sección) */\n.plp-franja {\n  margin: 0;\n  padding-bottom: 28px;\n}\n.plp-franja:last-of-type {\n  padding-bottom: 96px;\n}\n.plp-franja__cap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  padding: 20px 24px 10px;\n}\n.plp-franja__cap b {\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n.plp-selall {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n.plp-selall input {\n  cursor: pointer;\n}\n.plp-empty {\n  margin: 0 24px;\n  border: 1px dashed var(--border);\n  border-radius: var(--r-data);\n  padding: 16px 18px;\n  font-size: var(--fs-2xs);\n  color: var(--text-muted);\n  background: var(--bg-alt);\n}\n.plp-empty.is-err {\n  border-style: solid;\n  border-color: var(--danger);\n  color: var(--danger);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* ── tarjetas ── */\n.plp-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 0 24px;\n}\n.plp-card {\n  border: 1px solid var(--border);\n  border-radius: var(--r-dialog);\n  background: var(--bg-alt);\n  padding: 14px 16px;\n  cursor: pointer;\n  transition: border-color 0.12s ease;\n}\n.plp-card:hover {\n  border-color: var(--text-muted);\n}\n.plp-card.is-open {\n  border-color: var(--text-secondary);\n}\n.plp-card__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.plp-card__lead {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.plp-card__lead input[type='checkbox'] {\n  cursor: pointer;\n}\n.plp-card__right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.plp-card__chev {\n  font-family: var(--mono);\n  font-size: var(--fs-meta);\n  color: var(--text-muted);\n}\n.plp-date {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 6px;\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n  font-size: var(--fs-2xs);\n  color: var(--text-secondary);\n}\n.plp-money {\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n  font-size: var(--fs-note);\n  color: var(--text);\n  white-space: nowrap;\n}\n\n/* campos clave de la card */\n.plp-card__fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n  gap: 12px 24px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border-soft);\n}\n.plp-cf {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.plp-cf__l {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin-bottom: 3px;\n}\n.plp-cf__v {\n  font-size: var(--fs-ui);\n  color: var(--text);\n  line-height: 1.3;\n}\n.plp-cf__s {\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  font-family: var(--mono);\n  margin-top: 2px;\n  word-break: break-word;\n}\n.plp-cf__s.is-err {\n  color: var(--danger);\n}\n\n/* acciones (Shinkansen + Manual) */\n.plp-actions {\n  display: inline-flex;\n  gap: 8px;\n}\n.plp-rowbtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 28px;\n  padding: 0 12px;\n  border: 1px solid var(--ink-dark);\n  border-radius: var(--radius-0);\n  background: var(--ink-dark);\n  color: var(--cream);\n  font-family: var(--sans);\n  font-size: var(--fs-meta);\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n}\n[data-theme='dark'] .plp-rowbtn {\n  background: var(--cream);\n  color: var(--ink-dark);\n  border-color: var(--cream);\n}\n.plp-rowbtn--ghost {\n  background: transparent;\n  color: var(--text-secondary);\n  border-color: var(--border);\n}\n[data-theme='dark'] .plp-rowbtn--ghost {\n  background: transparent;\n  color: var(--text-secondary);\n  border-color: var(--border);\n}\n.plp-rowbtn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* ── detalle de soporte (expandido dentro de la card) ── */\n.plp-card__detail {\n  margin-top: 12px;\n  padding-top: 4px;\n  border-top: 1px solid var(--border);\n  cursor: default;\n}\n.plp-detail {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 14px 28px;\n  padding: 14px 0 4px;\n}\n.plp-detail__sec {\n  min-width: 0;\n}\n.plp-detail__h {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin: 0 0 8px;\n}\n.plp-field {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: 10px;\n  padding: 3px 0;\n  align-items: baseline;\n}\n.plp-field__l {\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n}\n.plp-field__v {\n  font-size: var(--fs-meta);\n  color: var(--text);\n  word-break: break-word;\n}\n.plp-field__v.is-mono {\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n  font-size: var(--fs-xs);\n  user-select: all;\n}\n\n/* paginación */\n.plp-more {\n  padding: 14px 24px 0;\n}\n.plp-morebtn {\n  height: 30px;\n  padding: 0 14px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-0);\n  background: var(--bg-alt);\n  color: var(--text-secondary);\n  font-family: var(--mono);\n  font-size: var(--fs-xs);\n  cursor: pointer;\n}\n.plp-morebtn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* barra de selección (lote → pago manual) */\n.plp-selbar {\n  position: fixed;\n  bottom: 18px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 40;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 10px 16px;\n  border-radius: var(--radius-0);\n  border: 1px solid var(--text);\n  background: var(--ink-dark);\n  color: var(--cream);\n  box-shadow: 0 10px 30px -8px rgba(0, 0, 0, 0.45);\n  font-size: var(--fs-2xs);\n}\n.plp-selbar__txt b {\n  font-family: var(--mono);\n}\n.plp-selbar__sp {\n  width: 8px;\n}\n.plp-selbar__ghost {\n  border: 1px solid rgba(242, 227, 181, 0.35);\n  background: transparent;\n  color: var(--cream);\n  height: 28px;\n  padding: 0 12px;\n  border-radius: var(--radius-0);\n  font-family: var(--sans);\n  font-size: var(--fs-meta);\n  cursor: pointer;\n}\n.plp-selbar__seal {\n  border: 1px solid var(--cream);\n  background: var(--cream);\n  color: var(--ink-dark);\n  height: 28px;\n  padding: 0 14px;\n  border-radius: var(--radius-0);\n  font-family: var(--sans);\n  font-size: var(--fs-meta);\n  font-weight: 500;\n  cursor: pointer;\n}\n.plp-selbar__seal:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* fecha del pago manual, dentro de la confirmación */\n.plp-paidat {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.plp-paidat__l {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.plp-paidat input {\n  font-family: var(--mono);\n  font-size: var(--fs-2xs);\n  padding: 5px 8px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-0);\n  background: var(--bg);\n  color: var(--text);\n}\n\n/* qué hecho es la fecha de la cabecera: cada carril muestra el suyo */\n.plp-date__l {\n  font-size: var(--fs-micro);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
